import * as serverConstants from "./serverConstant";


const AppConstants ={
   serverConstants,

};
export default AppConstants;